<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<div class="title-part"><a href="#/e9781466817081_toc01#toctitle9" id="title9"><span><strong class="b">PART II</strong></span></a></div>
<div class="illustype_image"><div class="caption"><div class="p"><span>Self-portrait, study for <em class="i">The Artist and His Mother</em>, c. 1936</span></div></div>
<div class="image"><img alt="e9781466817081_i0004.jpg" src="e9781466817081_i0004.jpg"/></div>
<a id="page_46"></a></div><a id="page_46">
</a><a id="page_47">
</a></div><a id="page_47">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466817081_p02.vue?173aed00